var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "SliderRow",
    {
      attrs: {
        id: _vm.id,
        label: _vm.$t(_vm.fieldConfig.label),
        value: _vm.fieldValue,
      },
      on: {
        "update:value": [
          function ($event) {
            _vm.fieldValue = $event
          },
          _vm.syncChange,
        ],
      },
    },
    [
      _c(
        "div",
        { attrs: { slot: "label" }, slot: "label" },
        [
          _c("span", [_vm._v(_vm._s(_vm.$t(_vm.fieldConfig.label)))]),
          _c(
            "ElPopover",
            {
              attrs: {
                placement: "right",
                trigger: "hover",
                "visible-arrow": false,
                "popper-class": "bio-search-setting__popover",
              },
            },
            [
              !_vm.isNW
                ? _c("AlignmentExplanation", {
                    attrs: {
                      "img-src": _vm.store.safeImagesUrl(
                        "similarityExplanation"
                      ),
                    },
                  })
                : [
                    _c("div", { staticClass: "popover-explain" }, [
                      _c("img", {
                        staticClass: "popover-explain__img mb-3",
                        attrs: {
                          src: _vm.store.safeImagesUrl(
                            "globalAlignmentSimilarityExplanation"
                          ),
                        },
                      }),
                      _c("div", { staticClass: "popover-explain--row" }, [
                        _c("span", { staticClass: "mr-1" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("Search.labels.alignmentIdentity")
                              ) +
                              "= "
                          ),
                        ]),
                        _c(
                          "span",
                          { staticClass: "popover-explain__vertical" },
                          [
                            _c("span", { staticClass: "px-1" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("Search.explanation.identityLength")
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("span", {
                              staticClass: "popover-explain__vertica--line",
                            }),
                            _c("span", { staticClass: "px-1" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("Search.explanation.alignLength")
                                  ) +
                                  " "
                              ),
                            ]),
                          ]
                        ),
                        _c("span", { staticClass: "mx-2" }, [_vm._v(" = ")]),
                        _c(
                          "span",
                          { staticClass: "popover-explain__vertical" },
                          [
                            _c("span", { staticClass: "px-1" }, [_vm._v("4")]),
                            _c("span", {
                              staticClass: "popover-explain__vertica--line",
                            }),
                            _c("span", { staticClass: "px-1" }, [_vm._v("8")]),
                          ]
                        ),
                      ]),
                    ]),
                  ],
              _c("PtIcon", {
                attrs: { slot: "reference", icon: "SolidInfo" },
                slot: "reference",
              }),
            ],
            2
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }